import { useEffect } from "react"
import GoogleMapsWrapper from "./GoogleMapsWrapper"

type Props = InternalProps & {
  googleMapsApiKey: string
}

type Position = {
  latitude: number,
  longitude: number
}

export const Geocoder = ({googleMapsApiKey, address, onGeocode}: Props) => {
  return <GoogleMapsWrapper apiKey={googleMapsApiKey}>
    <InternalGeocoder address={address} onGeocode={onGeocode} />
  </GoogleMapsWrapper>
}

export default Geocoder

type InternalProps = {
  address: string
  onGeocode: (position: Position) => void
}

const InternalGeocoder = ({address, onGeocode}: InternalProps) => {
  useEffect(() => {
    const geocoder = new google.maps.Geocoder()
    geocoder.geocode({ address }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results && results.length > 0 && results[0].geometry && results[0].geometry.location) {
          const location = results[0].geometry.location
          onGeocode({ latitude: location.lat(), longitude: location.lng() })
        }
      }
    })
  }, [address])
  return null
}
